module.exports = __webpack_public_path__ + "img/follow_2.07c78e0d.png";